import * as masterSetupImportApi from '../api/master-setup-import';
import * as workflowMasterSetupImportApi from '../api/workflow-master-setup-import';
import { BULK_IMPORT_APIS } from '../constants/MasterSetupConstants';

export const getImportApiCall = (isWorkflowMasterSetup, apiStep) => {
  switch (apiStep) {
    case BULK_IMPORT_APIS.INITIATE_IMPORT:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.initiateEntityImport
        : masterSetupImportApi.initiateMasterSetupImport;

    case BULK_IMPORT_APIS.IMPORT:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.importEntity
        : masterSetupImportApi.importMasterSetup;

    case BULK_IMPORT_APIS.CHECK_STATUS:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.entityImportStatus
        : masterSetupImportApi.masterSetupImportStatus;

    case BULK_IMPORT_APIS.DOWNLOAD_RESULT:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.downloadEntityImportResult
        : masterSetupImportApi.downloadMasterSetupImportResult;

    case BULK_IMPORT_APIS.IMPORT_HISTORY:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.entityImportHistory
        : masterSetupImportApi.masterSetupImportHistory;

    case BULK_IMPORT_APIS.DOWNLOAD_INITIAL_FILE:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.downloadEntityImportedFile
        : masterSetupImportApi.downloadMasterSetupImportedFile;

    case BULK_IMPORT_APIS.DOWNLOAD_TEMPLATE:
      return isWorkflowMasterSetup
        ? workflowMasterSetupImportApi.downloadEntityImportTemplate
        : masterSetupImportApi.downloadMasterSetupImportTemplate;

    default:
      return;
  }
};

export const getErrorMessage = (apiErrors, defaultMessage) => {
  if (Array.isArray(apiErrors)) {
    return apiErrors[0].errorMessage || defaultMessage;
  } else if (typeof apiErrors === 'object' && apiErrors !== null) {
    return apiErrors.errorMessage || defaultMessage;
  } else {
    return apiErrors || defaultMessage;
  }
};

export const getImportCountByStatusCode = (importStatuses, statusCode) => {
  return importStatuses.filter((record) => record.StatusCode === statusCode).length;
};

export const getRecordTitle = (errorCount) => {
  return errorCount === 1 ? 'record' : 'records';
};

export const parseNotificationUrl = (link) => {
  if (link) {
    const [pathname, search] = link.split('?');
    return { pathname, search };
  }

  return {};
};
